export var JoyDataServiceAction;
(function (JoyDataServiceAction) {
    JoyDataServiceAction["create"] = "create";
    JoyDataServiceAction["read"] = "read";
    JoyDataServiceAction["update"] = "update";
    JoyDataServiceAction["delete"] = "delete";
})(JoyDataServiceAction || (JoyDataServiceAction = {}));
export var JoyDataServiceQueryOption;
(function (JoyDataServiceQueryOption) {
    JoyDataServiceQueryOption["createdAt"] = "createdAt";
    JoyDataServiceQueryOption["limit"] = "limit";
    JoyDataServiceQueryOption["slug"] = "slug";
})(JoyDataServiceQueryOption || (JoyDataServiceQueryOption = {}));
export default class JoyDataService {
    static initialize(provider) {
        JoyDataService.provider = provider;
    }
    static get instance() {
        return JoyDataService.provider;
    }
}
JoyDataService.provider = null;
//# sourceMappingURL=JoyDataService.js.map